import { render } from "./OverlayRoomType.vue?vue&type=template&id=31ad1f6d&scoped=true"
import script from "./OverlayRoomType.vue?vue&type=script&lang=js"
export * from "./OverlayRoomType.vue?vue&type=script&lang=js"

import "./OverlayRoomType.vue?vue&type=style&index=0&id=31ad1f6d&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ad1f6d"]])

export default __exports__